var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.512 3.61L2.812.65A.5.5 0 002 1.04v5.92a.5.5 0 00.812.39l3.7-2.96a.5.5 0 000-.78z",
    fill: "#262A33",
    fillOpacity: 0.5
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNi41MTE5NiAzLjYwOTU3TDIuODEyMzUgMC42NDk4NzhDMi40ODQ5NyAwLjM4Nzk3MyAyIDAuNjIxMDU5IDIgMS4wNDAzMUwyIDYuOTU5NjlDMiA3LjM3ODk0IDIuNDg0OTcgNy42MTIwMyAyLjgxMjM1IDcuMzUwMTJMNi41MTE5NiA0LjM5MDQzQzYuNzYyMTYgNC4xOTAyNyA2Ljc2MjE2IDMuODA5NzMgNi41MTE5NiAzLjYwOTU3WiIgZmlsbD0iIzI2MkEzMyIgZmlsbC1vcGFjaXR5PSIwLjUiLz4KPC9zdmc+Cg==";
export { SvgTriangle as ReactComponent };